import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { translations } from "./i18n";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Team } from "./components/Team";
import { Network } from "./components/Network";
import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { ImpressumPage } from "./pages/Impressum";
import { DatenschutzPage } from "./pages/Datenschutz";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = ({ t }) => (
  <main>
    <Hero t={t} />
    <Services t={t} />
    <Team t={t} />
    <Network t={t} />
    <Gallery t={t} />
    <Contact t={t} />
  </main>
);

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("vm-lang") || "de");

  useEffect(() => {
    localStorage.setItem("vm-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <div className="App bg-[#08080a] min-h-screen">
      <Toaster position="bottom-right" theme="dark" />
      <BrowserRouter>
        <ScrollToTop />
        <Header t={t} lang={lang} setLang={setLang} />
        <Routes>
          <Route path="/" element={<Home t={t} />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
        </Routes>
        <Footer t={t} />
      </BrowserRouter>
    </div>
  );
}

export default App;
